// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AngleUp: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 9 5" width={width} height={height}>
            <path
                fill="currentColor"
                d="M5.133.723a.39.39 0 0 0-.514 0L.982 4.058a.315.315 0 0 0 0 .471c.14.13.373.13.513 0l3.381-3.1 3.38 3.1c.141.13.373.13.514 0a.315.315 0 0 0 0-.471z"
            />
        </svg>
    );
};

export default React.memo(AngleUp);
